let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ivK29"), load("2VGj6"), load("6XyGC")]).then(() => parcelRequire('cV69w'));